/* eslint-disable no-undef */
function getPlayerSize(config) {
  return `${document.getElementById(config.targetId).clientWidth}x${
    document.getElementById(config.targetId).clientHeight
  }`;
}

export default function contentParams(config, isVideoProducer) {
  return {
    pro_tp: isVideoProducer ? 'VIDEOPRODUCER' : 'EDITORIAL',
    pl_lo_id: `${parseInt(Math.random() * 10000, 10)}${Date.now().toString().substr(-4)}${parseInt(
      Math.random() * 10000000000,
      10,
    )}`,
    pl_lo_sz: getPlayerSize(config),
  };
}
